import React, { useEffect } from "react";
import Gradients from "../components/Gradients";
import ProductImages from "../components/ProductImages";
import Info from "../components/Info/Info";

const Home = () => {
  let shoes, shoeBackground, shoeHeight;
  const heading = 'About Me';
  const content = 'I\'m currently in my second year of college at Jadavpur University, Kolkata. I enjoy web development and spend my time building fun projects using the technologies I know of. Front end development is my forte - I\'m particularly interested in React and am actively learning it.';

  // for responsive behaviour
  const changeHeight = () => {
    let x = window.matchMedia("(max-width:1000px)");

    !shoes ? (shoeHeight = 0) : (shoeHeight = shoes[0].offsetHeight);

    if (x.matches) {
      if (shoeHeight === 0) {
        try {
          setTimeout(changeHeight, 50);
        } catch (error) {
          alert("Something is Wrong!!");
        }
      }
      if (shoeBackground) {
        shoeBackground.style.height = `${shoeHeight * 0.9}px`;
      }
    } else if (!!shoeBackground) {
      // go back to default
      shoeBackground.style.height = "475px";
    }
  };

  useEffect(() => {
    shoes = document.querySelectorAll(".shoe");
    shoeBackground = document.querySelector(".shoeBackground");
    changeHeight();
  }, []);
  window.addEventListener("resize", changeHeight);

  return (
    <div id="aboutSection" className="container">
      <div className="card">
        <div className="shoeBackground">
          <Gradients />
          <ProductImages />
        </div>
        <Info heading={heading} content={content} />
      </div>
    </div>
  );
};

export default Home;
